import React from 'react';

import { useQueryParam } from 'Shared/utils/hooks';
import QueryParamConstants from 'Shared/constants/QueryParams.constants';
import InviteTeammateModal from 'Shared/components/InviteTeammateModal/InviteTeammateModal';
import { WpButton, Size, Variant } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';

import './InviteTeammateButton.scss';

type Props = {
  size?: Size;
  workspaceId: string;
  teammateName?: string;
  invitedEmail?: string;
  workspaceTitle: string;
  onClick?: Function;
  icon?: string;
  btnText?: string;
  variant?: Variant;
};

function InviteTeammateButton({
  size,
  workspaceId,
  workspaceTitle,
  invitedEmail = '',
  teammateName = workspaceTitle,
  onClick,
  icon,
  btnText,
  variant = 'primary',
}: Props) {
  const [inviteModalParam, setInviteModalParam] = useQueryParam(QueryParamConstants.INVITE_BY_WORKSPACE_MODAL);

  const handleClick = () => {
    setInviteModalParam(true);
    if (onClick) {
      onClick();
    }
  };

  const handleModalClose = () => setInviteModalParam(null);

  return (
    <>
      {inviteModalParam && (
        <InviteTeammateModal
          isOpen
          workspaceId={workspaceId}
          workspaceTitle={teammateName || workspaceTitle}
          invitedEmail={invitedEmail}
          toggle={handleModalClose}
        />
      )}
      <WpButton onClick={handleClick} size={size} variant={variant}>
        {icon && <WpIcon name={icon} />}
        {btnText ? btnText : `Invite ${teammateName}`}
      </WpButton>
    </>
  );
}

export default InviteTeammateButton;
